export class EditProfileRequest
{
    constructor(
            public readonly fullname:string, 
            public readonly oldPassword:string, 
            public readonly newPassword:string, 
            public readonly email:string
        )
    {}
}
